<template>
  <div class="small">
          <bar-chart :height="300" :chart-data="CHARTDATA"></bar-chart>
  </div>
</template>

<script>
  import BarChart from '@/plugins/BarChart.js'

  export default {
      components: {
        BarChart
      },
        data: () => ({
          labels: [],
          data:[],
          datacollection:{},
          gradient: null,
      }),
      props: {
        show:{
            type: Boolean,
            default: false
        },
        rawdata: {
          type: Array,
          default: function(){ return []}
        }
      },
    watch: {
      show(v) {
        if(v){
          
           this.exportData()
            this.fillData(this.data,this.labels)
        }
       
        
      }
    },
    computed: {
      CHARTDATA() {
        return this.datacollection
      },
    },
    methods: {
      exportData() {
        this.labels = []
        this.data = []
       
        for (const item of this.rawdata) {
              this.labels.push(item.cashier)
              this.data.push(item.amount)
          }
    
      },
      fillData (_data, _labels) {
        
        this.datacollection = {
          labels:_labels,
          datasets: [
            {
               label: '--',
                backgroundColor: '#f87979',
              data: _data
            }
          ]
        }
        console.log(this.datacollection)
        // setTimeout(()=>{
        //   this.datacollection.datasets[0].backgroundColor = this.BGCOLOR
        //   console.log(this.datacollection.datasets[0].backgroundColor)
        // }, 1000)
        

      
      }
    }
  }
</script>

<style>
  .small {
    height: 300px;
  }
</style>